import React from "react";
import PropTypes from "prop-types";
import SVG from "../svg/Svg";
import "./styles.css";

const ButtonComponent = ({ title, svg, onClick, type, size, disabled }) => {
  return (
    <button
      style={size ? { width: size } : undefined}
      onClick={onClick}
      className={type ? type : "btn"}
      disabled={disabled}
    >
      <div>{title}</div>
      {svg && <div className="button_svg">{SVG[svg]}</div>}
    </button>
  );
};

ButtonComponent.propTypes = {
  title: PropTypes.string.isRequired,
  svg: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  size: PropTypes.string,
  // DEV-78: пока операция с секретом идёт, повторное нажатие запрещено.
  disabled: PropTypes.bool,
};

export default ButtonComponent;
